import React, { useCallback, useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import {
  LuMic,
  LuUser,
  LuUpload,
  LuLibrary,
  LuMicVocal,
  LuClock,
  LuVolume2,
  LuHistory,
  LuHandCoins,
  LuRefreshCw,
  LuCheck,
  LuX,
} from "react-icons/lu";
import AppModal from "../common/modal/AppModal";
import InsufficientBalanceModal from "../common/modal/InsufficientBalanceModal";
import { CLOSED_CREDIT_REFUSAL, creditRefusalState } from "../../utils/insufficientBalance";
import AIVoiceTab from "./AIVoiceTab";
import AvatarNarrationTab from "./AvatarNarrationTab";
import UploadSoundTab from "./UploadSoundTab";
import LibrarySoundTab from "./LibrarySoundTab";
import RecordSoundTab from "./RecordSoundTab";
import HistoryTab from "../add_image_modal/HistoryTab";
import i18n from "i18next";
import getMediaBoxSize from "../../utils/getMediaBoxSize";
import { recordPopupResult } from "../ai-chat/aiPopupResults";
import {
  useNarrationDrafts,
  isDraftApprovable,
  draftToSoundData,
  clearNarrationDraft,
} from "./narrationDraftStore";
import {
  isTalkingAvatarJob,
  applyTalkingAvatarFromJob,
} from "./talking_avatar/talkingAvatarInsert";
import { useTalkingAvatarJobNavIds } from "./talking_avatar/talkingAvatarJobStore";
import { tt } from "./talking_avatar/talkingAvatarI18n";
import "./_addSoundModal.scss";

const TABS = [
  { id: "ai", label: "AIVoice", icon: LuMic },
  { id: "avatar", label: "AvatarNarration", icon: LuUser },
  { id: "library", label: "FromLibrary", icon: LuLibrary },
  { id: "record", label: "RecordMyVoice", icon: LuMicVocal },
  { id: "upload", label: "UploadMyFile", icon: LuUpload },
];

const AddSoundModal = ({
  show,
  onClose,
  onCancel,
  onAddSound,
  onEditSound,
  onAddSoundForScene,
  onEditSoundForScene,
  onServerModal,
  onSoundSelected,
  navItemSelected,
  navItemsIds,
  voiceProfile,
  soundList,
  boxes,
  navItems,
  containedViews,
  containedViewSelected,
  boxSelected,
  pluginToolbars,
  onBoxAdded,
  initialTab,
  initialSoundIndex,
  initialStartTime,
  initialNarrationText,
  initialNarrationTextNavId,
  uploadFunction,
  allSoundLists,
  onInsufficientBalance: parentOnInsufficientBalance,
  onNavItemSelected,
}) => {
  const [activeTab, setActiveTab] = useState(initialTab || "ai");
  // Kaydedilmemiş AI anlatım taslağı olan sahneler (liste üzerinde sarı nokta).
  const narrationDrafts = useNarrationDrafts();
  // Doğal konuşan video işi süren / eklenmeyi bekleyen sahneler (mor nokta).
  // Yalnız sahne kümesi değişince yenilenir — işlerin ilerleme tick'leri modalı
  // yeniden çizdirmez.
  const talkingJobNavIds = useTalkingAvatarJobNavIds();
  const [selectedSceneId, setSelectedSceneId] = useState(navItemSelected);
  // Kaydet-ve-Ekle geri bildirimi: null → yok, "saving" → spinner döner,
  // "done" → "Sahneye eklendi" + Tamam. Modal-içi overlay (portal) olarak,
  // AI/Avatar sekmesinin ÜSTÜNDE render edilir; Tamam hepsini kapatır.
  const [saveOverlay, setSaveOverlay] = useState(null);
  const saveStartRef = useRef(0);
  // Tracks the last scene the user explicitly clicked in the modal's left panel.
  // Used to avoid a circular update: user clicks slide 2 → dispatch → navItemSelected
  // prop updates to 2 → useEffect would re-call setSelectedSceneId("2") and in
  // React 17 that extra call can race against the original setState before it commits.
  const lastModalSelectedRef = useRef(navItemSelected);

  // Editor → modal: when the editor navigates to a different scene, follow it —
  // but only if the change came from the editor (not from our own dispatch above).
  useEffect(() => {
    if (navItemSelected && navItemSelected !== lastModalSelectedRef.current) {
      setSelectedSceneId(navItemSelected);
    }
  }, [navItemSelected]);
  const [avatarCurrentView, setAvatarCurrentView] = useState("form");
  const [avatarProcessing, setAvatarProcessing] = useState(false);
  // Footer'daki "~süre" için AvatarNarrationTab'in bildirdiği saniye (sahne sesi
  // süresi ya da "yeni ses üret" tahmini). null → süre gösterilmez.
  const [avatarRenderSeconds, setAvatarRenderSeconds] = useState(null);
  // Avatar formundaki tüm gerekli seçimler tamam mı? "Avatar Oluştur" butonu buna
  // göre kilitlenir. Başlangıçta false → seçimler yapılana kadar kilitli.
  const [avatarCanCreate, setAvatarCanCreate] = useState(false);
  const [uploadedFile, setUploadedFile] = useState(null);
  const [uploadedAudioUrl, setUploadedAudioUrl] = useState(null);
  const avatarTabRef = useRef(null);
  const aiTabRef = useRef(null);
  const libraryTabRef = useRef(null);
  const recordTabRef = useRef(null);
  const uploadTabRef = useRef(null);
  const [aiState, setAiState] = useState({
    isGenerating: false,
    audioGeneratedInSession: false,
    readyToSave: false,
    canNarrateAllScenes: false,
  });
  // AI sekmesi footer'ında "Tüm sahneleri seslendir" kutusu. İşaretliyken kaydete
  // basılınca AIVoiceTab onay popup'ı açar ve seçili sesi tüm sahnelere uygular.
  const [narrateAllScenes, setNarrateAllScenes] = useState(false);
  // Sahne değişince / modal yeniden açılınca kutuyu sıfırla — bir sahnenin tercihi
  // diğerine sızmasın.
  useEffect(() => {
    setNarrateAllScenes(false);
  }, [selectedSceneId, show]);
  const [librarySelectionCount, setLibrarySelectionCount] = useState(0);
  const [recordedHasSound, setRecordedHasSound] = useState(false);

  // Credit check state — same pattern as AddImageModal
  const [creditCheckHandler, setCreditCheckHandler] = useState(null);
  const [creditInfo, setCreditInfo] = useState(null);
  const [creditLoading, setCreditLoading] = useState(false);
  const [creditPopoverOpen, setCreditPopoverOpen] = useState(false);
  const creditBtnRef = useRef(null);

  const handleCreditCheckReady = useCallback((handler) => {
    setCreditCheckHandler(() => handler);
  }, []);

  const handleCreditCheck = useCallback(async () => {
    if (!creditCheckHandler) return;
    if (creditPopoverOpen) {
      setCreditPopoverOpen(false);
      return;
    }
    setCreditLoading(true);
    setCreditInfo(null);
    try {
      const result = await creditCheckHandler();
      setCreditInfo(result);
      setCreditPopoverOpen(true);
    } catch {
      // silently ignore
    } finally {
      setCreditLoading(false);
    }
  }, [creditCheckHandler, creditPopoverOpen]);

  useEffect(() => {
    if (!creditPopoverOpen) return;
    const onClickOutside = (e) => {
      if (creditBtnRef.current && !creditBtnRef.current.contains(e.target)) {
        setCreditPopoverOpen(false);
      }
    };
    document.addEventListener("mousedown", onClickOutside);
    return () => document.removeEventListener("mousedown", onClickOutside);
  }, [creditPopoverOpen]);

  // Close popover on any tab switch
  useEffect(() => {
    setCreditPopoverOpen(false);
    setCreditInfo(null);
  }, [activeTab]);

  // When a parent (e.g. EditorModals) provides its own handler we forward to it
  // — this is required because this modal is sometimes unmounted via a
  // changing `key` prop, which would wipe any locally-held popup state.
  // Falls back to a self-contained popup if no parent handler is provided.
  const [insufficientBalance, setInsufficientBalance] = useState(CLOSED_CREDIT_REFUSAL);

  const handleInsufficientBalance = useCallback(
    (errData) => {
      if (typeof parentOnInsufficientBalance === "function") {
        parentOnInsufficientBalance(errData);
        onClose?.();
        return;
      }
      setInsufficientBalance(creditRefusalState(errData));
      onClose?.();
    },
    [onClose, parentOnInsufficientBalance]
  );

  const handleTabChange = useCallback((tabId) => {
    setActiveTab(tabId);
    // Tab değiştiğinde upload dosyasını sıfırla
    if (tabId !== "upload") {
      setUploadedFile(null);
      setUploadedAudioUrl(null);
    }
  }, []);

  const isHistoryTab = activeTab === "history";
  const shouldShowFooter =
    !isHistoryTab && !(activeTab === "avatar" && avatarCurrentView !== "form");

  // Avatar footer'ındaki "Avatar renders for ... · ~Xs" ipucu için sahne etiketi.
  // Hangi sahne olduğunu net göstermek için "Sahne {numara}: {ad}" formatı kullanılır.
  const selectedSceneIndex =
    navItemsIds && selectedSceneId ? navItemsIds.indexOf(selectedSceneId) : -1;
  const selectedSceneName = (() => {
    const num = selectedSceneIndex >= 0 ? selectedSceneIndex + 1 : null;
    const name =
      navItems && selectedSceneId && navItems[selectedSceneId]
        ? navItems[selectedSceneId].name
        : "";
    const base = `${i18n.t("Scene") || "Scene"} ${num ?? 1}`;
    return name ? `${base}: ${name}` : base;
  })();

  // Footer süre etiketi: sahne sesi süresi / yeni ses tahmini. AIVoiceTab ile
  // tutarlı dk/sn birimleri. null/0 → süre gösterilmez.
  const avatarDurationLabel = (() => {
    const sec = Math.round(Number(avatarRenderSeconds));
    if (!sec || isNaN(sec) || sec <= 0) return null;
    const secLabel = i18n.t("Seconds") || "sn";
    const minLabel = i18n.t("Minutes") || "dk";
    if (sec < 60) return `~${sec} ${secLabel}`;
    const m = Math.floor(sec / 60);
    const r = sec % 60;
    return r ? `~${m} ${minLabel} ${r} ${secLabel}` : `~${m} ${minLabel}`;
  })();

  const currentSoundList =
    allSoundLists && selectedSceneId ? allSoundLists[selectedSceneId] || [] : soundList || [];

  // Spinner overlay'ini başlat. Idempotent: başlangıç zaman damgasını bir kayıt
  // döngüsünde yalnızca bir kez basar (async yükleme handleConfirm'de başlatır,
  // senkron ekleme handleAIVoiceAdd'de — ikisi de bunu çağırır, çift damga yok).
  const beginSaveOverlay = useCallback(() => {
    if (!saveStartRef.current) saveStartRef.current = Date.now();
    setSaveOverlay("saving");
  }, []);

  // Ekleme bitince modalı HEMEN kapatma; spinner en az ~650ms görünsün, sonra
  // "Sahneye eklendi" kartına geç (Tamam ile kapanır).
  const finishSave = useCallback(() => {
    const started = saveStartRef.current || Date.now();
    const wait = Math.max(0, 650 - (Date.now() - started));
    setTimeout(() => setSaveOverlay("done"), wait);
  }, []);

  // Overlay'i tamamen temizle (Tamam / iptal / hata sonrası kayıt döngüsünü bitir).
  const clearSaveOverlay = useCallback(() => {
    saveStartRef.current = 0;
    setSaveOverlay(null);
  }, []);

  // "Tamam" → overlay + modal kapanır, sahneye dönülür.
  const handleSaveDone = useCallback(() => {
    clearSaveOverlay();
    onClose?.();
  }, [onClose, clearSaveOverlay]);

  const handleAIVoiceAdd = useCallback(
    (soundData, index, closeAfterAdd = true) => {
      // onSoundSelected varsa (toolbar'dan açıldıysa) — URL'yi doğrudan ilet.
      // Bu akış overlay göstermeden hemen kapanır.
      if (onSoundSelected && soundData?.file) {
        onSoundSelected(soundData.file);
        clearSaveOverlay();
        if (closeAfterAdd) onClose?.();
        return;
      }
      // Senkron sekmeler (AI/Kütüphane) için spinner'ı burada başlat. Async
      // sekmeler (yükleme/kayıt) zaten handleConfirm'de başlattı — idempotent.
      if (closeAfterAdd) {
        beginSaveOverlay();
      }
      const isCurrentScene = selectedSceneId === navItemSelected;
      if (index != null) {
        if (isCurrentScene) {
          onEditSound?.(index, soundData);
        } else {
          onEditSoundForScene?.(selectedSceneId, index, soundData);
        }
      } else {
        if (isCurrentScene) {
          onAddSound?.(soundData);
        } else {
          onAddSoundForScene?.(selectedSceneId, soundData);
        }
      }
      recordPopupResult({ feature: "sound", summary: "Added narration to the scene" });
      // Modalı hemen KAPATMA: "Sahneye eklendi" + Tamam kartını göster; Tamam
      // (handleSaveDone) kapatır. closeAfterAdd=false ise (ör. çoklu ekleme)
      // overlay'i kaldır, modal açık kalsın.
      if (closeAfterAdd) {
        finishSave();
      } else {
        clearSaveOverlay();
      }
    },
    [
      onAddSound,
      onEditSound,
      onAddSoundForScene,
      onEditSoundForScene,
      onClose,
      onSoundSelected,
      selectedSceneId,
      navItemSelected,
      beginSaveOverlay,
      finishSave,
      clearSaveOverlay,
    ]
  );

  // "Tümünü onayla": sahnelerde bekleyen, sesi hazır ve metni sonradan
  // değişmemiş tüm AI anlatım taslaklarını tek seferde sahnelerine yaz.
  // Taslağın ait olduğu kayıtlı ses (soundFile) hâlâ listede ise o girişi
  // günceller, değilse yeni ses ekler. Sahne sırası navItemsIds'e göre.
  const approvableDraftIds = (navItemsIds || []).filter((id) =>
    isDraftApprovable(narrationDrafts[id])
  );
  const pendingDraftCount = Object.keys(narrationDrafts).filter((id) =>
    (navItemsIds || []).includes(id)
  ).length;
  // Herhangi bir sahnede ses hâlâ üretiliyorsa "Tümünü kaydet" kilitli: yarım
  // kalan üretim atlanıp kullanıcı eksik kaydı "tümü" sanmasın.
  const anyDraftGenerating =
    !!aiState.isGenerating ||
    Object.keys(narrationDrafts).some(
      (id) => (navItemsIds || []).includes(id) && narrationDrafts[id]?.status === "generating"
    );
  const saveAllDisabled = anyDraftGenerating || approvableDraftIds.length === 0;

  const handleApproveAllDrafts = useCallback(() => {
    if (saveAllDisabled) return;
    beginSaveOverlay();
    approvableDraftIds.forEach((sceneId) => {
      const d = narrationDrafts[sceneId];
      const list = (allSoundLists && allSoundLists[sceneId]) || [];
      let index = null;
      if (d.soundFile) {
        if (d.soundIndex != null && list[d.soundIndex]?.file === d.soundFile) index = d.soundIndex;
        else {
          const found = list.findIndex((snd) => snd?.file === d.soundFile);
          if (found >= 0) index = found;
        }
      }
      const soundData = draftToSoundData(d, navItemsIds.indexOf(sceneId) + 1);
      clearNarrationDraft(sceneId);
      const isCurrentScene = sceneId === navItemSelected;
      if (index != null) {
        if (isCurrentScene) onEditSound?.(index, soundData);
        else onEditSoundForScene?.(sceneId, index, soundData);
      } else if (isCurrentScene) {
        onAddSound?.(soundData);
      } else {
        onAddSoundForScene?.(sceneId, soundData);
      }
    });
    recordPopupResult({ feature: "sound", summary: "Approved narration drafts" });
    finishSave();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    saveAllDisabled,
    narrationDrafts,
    navItemsIds,
    allSoundLists,
    navItemSelected,
    onAddSound,
    onEditSound,
    onAddSoundForScene,
    onEditSoundForScene,
    beginSaveOverlay,
    finishSave,
  ]);

  const addAvatarVideoToScene = useCallback(
    async (url, name) => {
      if (!onBoxAdded || !url) {
        onClose?.();
        return;
      }
      const IdealStudio = require("../../../core/editor/main").default;
      const { isSlide, isContainedView } = require("../../../common/utils");
      const { ID_PREFIX_BOX } = require("../../../common/constants");
      const { randomPositionGenerator } = require("../clipboard/clipboard.utils");
      const { createBox } = require("../../../common/common_tools");

      const pluginName = "EnrichedPlayer";
      const plugin = IdealStudio.Plugins.get(pluginName);
      if (!plugin) {
        onClose?.();
        return;
      }

      const navItem =
        containedViewSelected && containedViews && containedViews[containedViewSelected]
          ? containedViews[containedViewSelected]
          : navItems && navItems[navItemSelected];

      if (!navItem) {
        onClose?.();
        return;
      }

      const cv =
        containedViewSelected &&
        containedViews &&
        containedViews[containedViewSelected] &&
        isContainedView(containedViewSelected);
      const cvslide = cv && isSlide(navItem.type);
      const inASlide = (!cv && isSlide(navItem.type)) || cvslide;
      const parent = inASlide ? navItem.id : navItem.boxes && navItem.boxes[0];

      const { width, height, widthUnit, heightUnit } = await getMediaBoxSize(url, "video");

      const initialParams = {
        parent,
        container: 0,
        name: pluginName,
        position: {
          x: randomPositionGenerator(10, 30),
          y: randomPositionGenerator(10, 30),
          type: "absolute",
        },
        id: ID_PREFIX_BOX + Date.now(),
        page: cv ? containedViewSelected : navItem.id || navItemSelected || 0,
        url,
        width,
        height,
        widthUnit,
        heightUnit,
        fileName: name,
      };

      createBox(initialParams, pluginName, inASlide, onBoxAdded, boxes);
      onClose?.();
    },
    [
      onBoxAdded,
      boxes,
      navItems,
      navItemSelected,
      containedViews,
      containedViewSelected,
      boxSelected,
      pluginToolbars,
      onClose,
    ]
  );

  const handleHistoryAdd = useCallback(
    (url, name, mediaType, job) => {
      // Doğal konuşan video: sesi sahnenin anlatımıyla değiştir + videoyu sessiz
      // ekle — job'un KENDİ sahnesine (geçmişten yeniden ekleme → force).
      // Modal ancak sonuç sahneye girince kapanır; sonuç alınamazsa sebep
      // geçmiş sekmesinde satır içi gösterilir (HistoryTab, satır onaylanmaz).
      if (job && isTalkingAvatarJob(job)) {
        return applyTalkingAvatarFromJob(job, { force: true, onNavigate: onNavItemSelected }).then(
          (out) => {
            if (out && out.ok) {
              onClose?.();
              return out;
            }
            // The same add is already running (double click): nothing to report.
            if (out && out.reason === "inFlight") return { ok: false };
            return {
              ok: false,
              message:
                out && out.reason === "noResult"
                  ? tt(
                      "TalkingAvatar.History.NoResult",
                      "Bu işin sonucu alınamadı; sahneye eklenemedi."
                    )
                  : tt(
                      "TalkingAvatar.Result.AddFailed",
                      "Sahneye eklenemedi; lütfen tekrar deneyin."
                    ),
            };
          }
        );
      }
      if (mediaType === "avatar") {
        addAvatarVideoToScene(url, name);
        return;
      }
      handleAIVoiceAdd({ file: url, fileName: name });
    },
    [handleAIVoiceAdd, addAvatarVideoToScene, onNavItemSelected, onClose]
  );

  const handleConfirm = useCallback(() => {
    // Avatar kendi ilerleme/işleme akışına sahip — overlay'i ona uygulamıyoruz.
    if (activeTab === "avatar") {
      avatarTabRef.current?.handleCreate();
      return;
    }
    // Yükleme sekmesi: ses AĞ üzerinden yüklenir; spinner'ı bu bekleme boyunca
    // göstermek için burada başlat (onError ile hata durumunda temizlenir).
    // Diğer sekmelerde (AI/Kütüphane/Kayıt) spinner'ı burada BAŞLATMA: AI'da
    // "Tüm sahneleri seslendir" açıkken handleAddSound commit etmeden onay modalı
    // açar; spinner'ı erken açsak o modal overlay'in arkasında kilitlenirdi. Bu
    // sekmelerde spinner gerçek commit anında (handleAIVoiceAdd) başlar.
    if (activeTab === "upload") {
      beginSaveOverlay();
    }
    if (activeTab === "upload") {
      uploadTabRef.current?.handleSave();
    } else if (activeTab === "ai") {
      aiTabRef.current?.handleAddSound();
    } else if (activeTab === "library") {
      libraryTabRef.current?.handleAddSelected();
    } else if (activeTab === "record") {
      recordTabRef.current?.handleSave();
    }
  }, [activeTab, beginSaveOverlay]);

  const confirmDisabled =
    (activeTab === "avatar" && (avatarProcessing || !avatarCanCreate)) ||
    (activeTab === "ai" &&
      (aiState.isGenerating || !(aiState.readyToSave ?? aiState.audioGeneratedInSession))) ||
    (activeTab === "library" && librarySelectionCount === 0) ||
    (activeTab === "upload" && !uploadedFile) ||
    (activeTab === "record" && !recordedHasSound);

  const confirmLabel =
    activeTab === "avatar" && avatarProcessing
      ? i18n.t("CreatingAvatar") || "Oluşturuluyor..."
      : activeTab === "avatar"
        ? i18n.t("CreateAvatar") || "Avatar Oluştur"
        : activeTab === "ai"
          ? i18n.t("Save") || "Kaydet"
          : activeTab === "record" || activeTab === "upload"
            ? i18n.t("SaveAndAdd")
            : i18n.t("AddSound");

  const confirmTitle =
    activeTab === "ai" && !(aiState.readyToSave ?? aiState.audioGeneratedInSession)
      ? i18n.t("PleaseGenerateVoiceFirst") || "Önce ses oluşturun"
      : undefined;

  const titleWithTabs = (
    <div className="add-sound-modal__title-with-tabs">
      <span className="add-sound-modal__title-text">
        {activeTab === "avatar"
          ? i18n.t("AvatarModalTitle") || "Avatar"
          : i18n.t("SoundModalTitle") || "Sound"}
      </span>
      <div className="add-sound-modal__tabs add-sound-modal__tabs--inline">
        {TABS.map((tab) => {
          const Icon = tab.icon;
          return (
            <OverlayTrigger
              key={tab.id}
              placement="bottom"
              delay={{ show: 300, hide: 0 }}
              overlay={
                <Tooltip id={`add-sound-tab-tooltip-${tab.id}`}>
                  {i18n.t(`SoundTabTooltip.${tab.id}`)}
                </Tooltip>
              }
            >
              <button
                type="button"
                onClick={() => handleTabChange(tab.id)}
                className={`add-sound-modal__tab${activeTab === tab.id ? " add-sound-modal__tab--active" : ""}`}
              >
                <span className="add-sound-modal__tab-icon">
                  <Icon />
                </span>
                <span className="add-sound-modal__tab-label">{i18n.t(tab.label)}</span>
              </button>
            </OverlayTrigger>
          );
        })}
      </div>
    </div>
  );

  // Shared credit button + popover — used in both AI Voice and Avatar footers
  const creditBtnJsx = (
    <div ref={creditBtnRef} style={{ position: "relative", flexShrink: 0 }}>
      <button
        type="button"
        onClick={handleCreditCheck}
        disabled={creditLoading}
        title={i18n.t("CreditEstimate.Tooltip")}
        style={{
          display: "inline-flex",
          alignItems: "center",
          gap: "6px",
          padding: "9px 16px",
          borderRadius: "12px",
          border: `1px solid ${creditPopoverOpen ? "#c4b5fd" : "#dce3f3"}`,
          background: creditPopoverOpen ? "#eef2ff" : "#f8fafc",
          color: creditPopoverOpen ? "#7c3aed" : "#64748b",
          fontSize: "14px",
          fontWeight: 600,
          cursor: creditLoading ? "wait" : "pointer",
          transition: "background 0.18s ease, color 0.18s ease, border-color 0.18s ease",
          outline: "none",
          whiteSpace: "nowrap",
        }}
      >
        {creditLoading ? (
          <LuRefreshCw size={14} style={{ animation: "asm-spin 0.8s linear infinite" }} />
        ) : (
          <LuHandCoins size={15} style={{ color: "#f59e0b" }} />
        )}
        <span>
          {creditLoading ? i18n.t("CreditEstimate.Loading") : i18n.t("CreditEstimate.Button")}
        </span>
      </button>

      {creditPopoverOpen && creditInfo && (
        <div
          style={{
            position: "absolute",
            bottom: "calc(100% + 10px)",
            left: 0,
            background: "#ffffff",
            borderRadius: "12px",
            border: "1px solid #e2e8f0",
            padding: "16px 20px",
            minWidth: "240px",
            boxShadow: "0 4px 24px rgba(15, 23, 42, 0.12)",
            zIndex: 9999,
            fontSize: "13px",
            lineHeight: 1.6,
          }}
        >
          <div
            style={{
              position: "absolute",
              bottom: -7,
              left: 20,
              width: 13,
              height: 13,
              background: "#ffffff",
              border: "1px solid #e2e8f0",
              borderTop: "none",
              borderLeft: "none",
              transform: "rotate(45deg)",
            }}
          />
          <div
            style={{
              fontWeight: 700,
              marginBottom: 12,
              fontSize: "14px",
              color: "#1e293b",
              display: "flex",
              alignItems: "center",
              gap: 7,
            }}
          >
            <LuHandCoins size={15} style={{ color: "#f59e0b" }} />
            {i18n.t("CreditEstimate.Title")}
          </div>
          {creditInfo.providers &&
            creditInfo.providers.map((p, idx) => (
              <div
                key={idx}
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: 6,
                }}
              >
                <span style={{ color: "#64748b", fontSize: "13px" }}>{p.label}</span>
                <span style={{ fontWeight: 600, color: "#1e293b", fontSize: "13px" }}>
                  {p.cost.toFixed(2)}&nbsp;
                  <span style={{ color: "#8b95af", fontWeight: 400 }}>
                    {i18n.t("ImageHistory.Credits")}
                  </span>
                </span>
              </div>
            ))}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: 14,
              paddingBottom: 14,
              borderBottom: "1px solid #f1f5f9",
              marginTop: 6,
            }}
          >
            <span style={{ color: "#64748b" }}>{i18n.t("CreditEstimate.Balance")}</span>
            <span style={{ fontWeight: 700, color: "#1e293b" }}>
              {creditInfo.availableCredits.toFixed(2)}&nbsp;
              <span style={{ color: "#8b95af", fontWeight: 400 }}>
                {i18n.t("ImageHistory.Credits")}
              </span>
            </span>
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 6,
              padding: "7px 12px",
              borderRadius: 8,
              background: creditInfo.hasSufficientBalance
                ? "rgba(124,58,237,0.08)"
                : "rgba(239,68,68,0.08)",
              color: creditInfo.hasSufficientBalance ? "#7c3aed" : "#ef4444",
              fontWeight: 600,
              fontSize: "12px",
            }}
          >
            {creditInfo.hasSufficientBalance
              ? `✓ ${i18n.t("CreditEstimate.Sufficient")}`
              : `✗ ${i18n.t("CreditEstimate.Insufficient")}`}
          </div>
        </div>
      )}
    </div>
  );

  return (
    <>
      <AppModal
        show={show}
        onClose={onClose}
        title={titleWithTabs}
        className="addSoundModal"
        size="xl"
        bodyProps={{ className: "add-sound-modal__body" }}
        footerProps={{ className: "add-sound-modal__footer" }}
        cancelLabel={shouldShowFooter ? i18n.t("Cancel") || "Vazgeç" : undefined}
        onCancel={onCancel || onClose}
        confirmLabel={shouldShowFooter ? confirmLabel : undefined}
        onConfirm={handleConfirm}
        confirmDisabled={confirmDisabled}
        confirmTitle={confirmTitle}
        footer={
          shouldShowFooter && activeTab === "avatar" ? (
            <>
              <style>{`@keyframes asm-spin{from{transform:rotate(0deg)}to{transform:rotate(360deg)}}`}</style>
              <div className="app-modal__footer add-sound-modal__avatar-footer">
                {/* Left: credit button + hint */}
                <div
                  style={{ display: "flex", alignItems: "center", gap: 12, minWidth: 0, flex: 1 }}
                >
                  {creditBtnJsx}
                  <span
                    className="add-sound-modal__avatar-footer-hint"
                    style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}
                  >
                    {avatarDurationLabel
                      ? i18n.t("AvatarRendersForScene", {
                          scene: selectedSceneName,
                          duration: avatarDurationLabel,
                          defaultValue: "Avatar renders for {{scene}} · {{duration}}",
                        })
                      : i18n.t("AvatarRendersForSceneNoDuration", {
                          scene: selectedSceneName,
                          defaultValue: "Avatar renders for {{scene}}",
                        })}
                  </span>
                </div>
                {/* Right: Cancel + Create */}
                <div className="add-sound-modal__avatar-footer-actions">
                  <button
                    type="button"
                    className="app-modal__btn app-modal__btn--ghost"
                    onClick={onCancel || onClose}
                  >
                    {i18n.t("Cancel") || "Vazgeç"}
                  </button>
                  <button
                    type="button"
                    className="app-modal__btn app-modal__btn--primary"
                    onClick={handleConfirm}
                    disabled={confirmDisabled}
                    title={
                      !avatarProcessing && !avatarCanCreate
                        ? i18n.t("AvatarCompleteFieldsHint") ||
                          "Please complete the required selections first."
                        : confirmTitle
                    }
                  >
                    {confirmLabel}
                  </button>
                </div>
              </div>
            </>
          ) : shouldShowFooter && activeTab === "ai" ? (
            <>
              <style>{`@keyframes asm-spin{from{transform:rotate(0deg)}to{transform:rotate(360deg)}}`}</style>
              <div className="app-modal__footer add-sound-modal__avatar-footer">
                {creditBtnJsx}
                <div className="add-sound-modal__avatar-footer-actions">
                  {/* Birden fazla sahnede taslak varken "Tüm sahneleri seslendir"
                      anlamsız (taslaklar zaten "Tümünü kaydet" ile yazılır) → gizli. */}
                  {aiState.canNarrateAllScenes && pendingDraftCount <= 1 && (
                    <label className="add-sound-modal__narrate-all-check">
                      <input
                        type="checkbox"
                        checked={narrateAllScenes}
                        onChange={(e) => setNarrateAllScenes(e.target.checked)}
                      />
                      <span>
                        {i18n.t("NarrateScope.NarrateAllCheckbox") || "Tüm sahneleri seslendir"}
                      </span>
                    </label>
                  )}
                  <button
                    type="button"
                    className="app-modal__btn app-modal__btn--ghost"
                    onClick={onCancel || onClose}
                  >
                    {i18n.t("Cancel") || "Vazgeç"}
                  </button>
                  {/* Birden fazla sahnede taslak varsa hepsini tek seferde onayla.
                      Tek tek onay: her sahnenin taslak notundaki "Onayla". */}
                  {pendingDraftCount > 1 && (
                    <button
                      type="button"
                      className="app-modal__btn app-modal__btn--primary"
                      onClick={handleApproveAllDrafts}
                      disabled={saveAllDisabled}
                      title={
                        anyDraftGenerating
                          ? i18n.t("NarrationDraft.SaveAllWaitGenerating") ||
                            "Oluşturulan ses bitene kadar tümü kaydedilemez."
                          : approvableDraftIds.length < pendingDraftCount
                            ? i18n.t("NarrationDraft.ApproveAllPartial", {
                                ready: approvableDraftIds.length,
                                total: pendingDraftCount,
                              }) ||
                              `${approvableDraftIds.length}/${pendingDraftCount} taslak hazır; diğerleri üretiliyor veya metni değişmiş.`
                            : undefined
                      }
                    >
                      {i18n.t("NarrationDraft.SaveAll") || "Tümünü kaydet"}
                    </button>
                  )}
                  <button
                    type="button"
                    className="app-modal__btn app-modal__btn--primary"
                    onClick={handleConfirm}
                    disabled={confirmDisabled}
                    title={confirmTitle}
                  >
                    {confirmLabel}
                  </button>
                </div>
              </div>
            </>
          ) : undefined
        }
        headerActions={
          <button
            type="button"
            onClick={() => setActiveTab(activeTab === "history" ? "ai" : "history")}
            title={i18n.t("ImageHistory.Tab") || "Etkinlik Günlüğü"}
            className={`app-modal__toggle-btn${activeTab === "history" ? " app-modal__toggle-btn--active" : ""}`}
          >
            <LuHistory size={16} />
          </button>
        }
      >
        <div className="add-sound-modal">
          <div className="add-sound-modal__layout">
            {navItemsIds && navItemsIds.length > 0 && navItems && (
              <div className="add-sound-modal__scene-list">
                <div className="add-sound-modal__scene-list-header">
                  {i18n.t("Scenes") || "Sahneler"}
                </div>
                {navItemsIds.map((sceneId, idx) => {
                  const sceneSounds = (allSoundLists && allSoundLists[sceneId]) || [];
                  const hasDraft = !!narrationDrafts[sceneId];
                  const isActive = selectedSceneId === sceneId;
                  return (
                    <button
                      key={sceneId}
                      type="button"
                      className={`add-sound-modal__scene-item${isActive ? " add-sound-modal__scene-item--active" : ""}`}
                      onClick={() => {
                        lastModalSelectedRef.current = sceneId;
                        setSelectedSceneId(sceneId);
                        onNavItemSelected?.(sceneId);
                      }}
                      title={
                        (navItems[sceneId] && navItems[sceneId].name) ||
                        `${i18n.t("Scene") || "Sahne"} ${idx + 1}`
                      }
                    >
                      <span className="add-sound-modal__scene-main">
                        <span className="add-sound-modal__scene-index">{idx + 1}</span>
                        <span className="add-sound-modal__scene-name">
                          {(navItems[sceneId] && navItems[sceneId].name) ||
                            `${i18n.t("Scene") || "Sahne"} ${idx + 1}`}
                        </span>
                        {hasDraft && (
                          <span
                            className="add-sound-modal__scene-draft-dot"
                            title={
                              i18n.t("NarrationDraft.SceneHasDraft") ||
                              "Bu sahnede kaydedilmemiş anlatım taslağı var"
                            }
                          />
                        )}
                        {talkingJobNavIds.has(sceneId) && (
                          <span
                            className="add-sound-modal__scene-draft-dot add-sound-modal__scene-draft-dot--talking"
                            title={i18n.t("TalkingAvatar.SceneHasJob", {
                              defaultValue: "Bu sahnede doğal konuşan video işi var",
                            })}
                          />
                        )}
                        {sceneSounds.length > 0 && (
                          <span className="add-sound-modal__scene-badge">
                            <LuVolume2 />
                          </span>
                        )}
                      </span>
                      {sceneSounds.length > 0 && (
                        <span className="add-sound-modal__scene-sounds">
                          {(() => {
                            const first = sceneSounds[0];
                            // voiceName ham provider id'sine eşitse (eski/bozuk
                            // kayıt) etikette id gösterme; dosya adına düş.
                            const vn = first && first.voiceData && first.voiceData.voiceName;
                            const vid = first && first.voiceData && first.voiceData.voiceId;
                            const soundLabel =
                              (vn && vn !== vid ? vn : "") ||
                              (first && first.name) ||
                              (first && first.file
                                ? first.file.split("/").pop().split("?")[0]
                                : "") ||
                              `#1`;
                            return (
                              <span
                                className="add-sound-modal__scene-sound-chip"
                                title={soundLabel}
                              >
                                <LuVolume2 />
                                <span className="add-sound-modal__scene-sound-chip-label">
                                  {soundLabel}
                                </span>
                              </span>
                            );
                          })()}
                          {sceneSounds.length > 1 && (
                            <span className="add-sound-modal__scene-sound-more">
                              +{sceneSounds.length - 1}
                            </span>
                          )}
                        </span>
                      )}
                    </button>
                  );
                })}
              </div>
            )}
            <div className="add-sound-modal__tab-content">
              {activeTab === "ai" ? (
                <AIVoiceTab
                  ref={aiTabRef}
                  key={`ai-voice-${selectedSceneId}-${currentSoundList?.length || 0}-${show}-${initialSoundIndex ?? ""}`}
                  navItemSelected={selectedSceneId}
                  navItemsIds={navItemsIds}
                  sceneName={
                    (navItems && navItems[selectedSceneId] && navItems[selectedSceneId].name) || ""
                  }
                  voiceProfile={voiceProfile}
                  onServerModal={onServerModal}
                  onCancel={onCancel || onClose}
                  onAddSound={handleAIVoiceAdd}
                  onEditSound={onEditSound}
                  soundList={currentSoundList}
                  allSoundLists={allSoundLists}
                  initialSoundIndex={initialSoundIndex}
                  initialStartTime={initialStartTime}
                  initialNarrationText={initialNarrationText}
                  initialNarrationTextNavId={initialNarrationTextNavId}
                  onStateChange={setAiState}
                  onInsufficientBalance={handleInsufficientBalance}
                  onCreditCheckReady={handleCreditCheckReady}
                  // Checkbox gizliyken (çoklu taslak) önceden işaretli kalsa da uygulanmaz.
                  narrateAllScenes={narrateAllScenes && pendingDraftCount <= 1}
                />
              ) : null}
              {activeTab === "avatar" ? (
                <AvatarNarrationTab
                  ref={avatarTabRef}
                  onElementSelected={onBoxAdded}
                  onServerModal={onServerModal}
                  navItemSelected={selectedSceneId}
                  navItemsIds={navItemsIds}
                  voiceProfile={voiceProfile}
                  soundList={currentSoundList}
                  boxes={boxes}
                  navItems={navItems}
                  containedViews={containedViews}
                  containedViewSelected={containedViewSelected}
                  boxSelected={boxSelected}
                  pluginToolbars={pluginToolbars}
                  onBoxAdded={onBoxAdded}
                  onClose={onClose}
                  onViewChange={setAvatarCurrentView}
                  onProcessingChange={setAvatarProcessing}
                  onRenderSecondsChange={setAvatarRenderSeconds}
                  onCanCreateChange={setAvatarCanCreate}
                  onInsufficientBalance={handleInsufficientBalance}
                  onCreditCheckReady={handleCreditCheckReady}
                  onNavItemSelected={onNavItemSelected}
                />
              ) : null}
              {activeTab === "upload" ? (
                <UploadSoundTab
                  ref={uploadTabRef}
                  onFileUpload={(file) => {
                    setUploadedFile(file);
                    if (file) {
                      const url = URL.createObjectURL(file);
                      setUploadedAudioUrl(url);
                    } else {
                      setUploadedAudioUrl(null);
                    }
                  }}
                  onServerModal={onServerModal}
                  uploadFunction={uploadFunction}
                  onAddSound={(soundData) => handleAIVoiceAdd(soundData)}
                  onError={() => {
                    clearSaveOverlay();
                    onServerModal?.("", i18n.t("SoundUploadFailed") || "Ses yüklenemedi", false);
                  }}
                />
              ) : null}
              {activeTab === "library" ? (
                <LibrarySoundTab
                  ref={libraryTabRef}
                  onAddSound={(soundData, closeAfterAdd) =>
                    handleAIVoiceAdd(soundData, null, closeAfterAdd)
                  }
                  onSelectionChange={setLibrarySelectionCount}
                  allSoundLists={allSoundLists}
                  navItemsIds={navItemsIds}
                  navItemSelected={selectedSceneId}
                  soundList={currentSoundList}
                  initialSoundIndex={initialSoundIndex}
                  initialStartTime={initialStartTime}
                />
              ) : null}
              {activeTab === "record" ? (
                <RecordSoundTab
                  ref={recordTabRef}
                  onAddSound={(soundData) => {
                    handleAIVoiceAdd(soundData);
                  }}
                  onServerModal={onServerModal}
                  uploadFunction={uploadFunction}
                  onStateChange={setRecordedHasSound}
                />
              ) : null}
              {activeTab === "history" ? (
                <HistoryTab mediaTypes={["audio", "avatar"]} onAddToScene={handleHistoryAdd} />
              ) : null}
            </div>
          </div>
        </div>
      </AppModal>

      {/* Kaydet-ve-Ekle geri bildirimi. Portal + z-index 3000090 → dialog
          band'in tepesi, yani AddSoundModal'ın (pageModal 3000000) ÜSTÜNDE.
          "saving": spinner döner. "done": başarı kartı (sağ üst X → hepsini
          kapatıp sahneye döner). Tasarım: sol hizalı, yeşil çek halkası,
          başlık + alt metin (Kaydetme Başarılı kartıyla aynı dil). */}
      {saveOverlay &&
        createPortal(
          <div className="asm-save-overlay">
            <style>{`
              @keyframes asm-spin{from{transform:rotate(0)}to{transform:rotate(360deg)}}
              .asm-save-overlay{position:fixed;inset:0;z-index:3000090;display:flex;
                align-items:center;justify-content:center;background:rgba(15,23,42,0.4);}
              .asm-save-card{position:relative;background:#fff;border-radius:16px;
                box-shadow:0 24px 60px rgba(15,23,42,0.18);padding:30px 34px 32px;
                min-width:340px;max-width:420px;display:flex;flex-direction:column;
                align-items:flex-start;gap:14px;text-align:left;
                font-family:'Figtree',sans-serif;}
              .asm-save-close{position:absolute;top:16px;right:16px;background:none;
                border:none;cursor:pointer;color:#9ca3af;width:32px;height:32px;
                display:flex;align-items:center;justify-content:center;border-radius:8px;
                transition:background .15s,color .15s;}
              .asm-save-close:hover{background:#f3f4f6;color:#374151;}
              .asm-save-spinner{width:64px;height:64px;border-radius:50%;
                border:6px solid #ede9fe;border-top-color:#6d5dfc;
                animation:asm-spin .8s linear infinite;}
              .asm-save-check{width:76px;height:76px;border-radius:50%;background:#dcfce7;
                display:flex;align-items:center;justify-content:center;
                box-shadow:0 0 0 8px rgba(34,197,94,0.10);}
              .asm-save-title{font-size:19px;font-weight:700;color:#111827;
                line-height:1.3;margin-top:6px;}
              .asm-save-sub{font-size:14px;color:#6b7280;line-height:1.5;margin-top:-4px;}
            `}</style>
            <div className="asm-save-card">
              {saveOverlay === "saving" ? (
                <>
                  <div className="asm-save-spinner" />
                  <div className="asm-save-title">Ses ekleniyor...</div>
                  <div className="asm-save-sub">Lütfen bekleyin.</div>
                </>
              ) : (
                <>
                  <button
                    type="button"
                    className="asm-save-close"
                    onClick={handleSaveDone}
                    aria-label="Kapat"
                  >
                    <LuX size={18} />
                  </button>
                  <div className="asm-save-check">
                    <LuCheck size={34} color="#16a34a" strokeWidth={2.5} />
                  </div>
                  <div className="asm-save-title">Ses Eklendi</div>
                  <div className="asm-save-sub">Ses sahneye başarıyla eklendi.</div>
                </>
              )}
            </div>
          </div>,
          document.body
        )}

      <InsufficientBalanceModal
        show={insufficientBalance.show}
        onClose={() => setInsufficientBalance((prev) => ({ ...prev, show: false }))}
        requestedAmount={insufficientBalance.requestedAmount}
        currentBalance={insufficientBalance.currentBalance}
        kind={insufficientBalance.kind}
        teamName={insufficientBalance.teamName}
        resetsAt={insufficientBalance.resetsAt}
      />
    </>
  );
};

export default AddSoundModal;
